// extracted by mini-css-extract-plugin
export default {"base":"Search_base__-2vrs","input":"Search_input__H3S-e","focus":"Search_focus__aRNRD"};